import React from 'react';
import useUser, { emptyUser, IUser } from './useUser';

export interface IUserProvider {
	data: IUser;
	fetch: (id?: string) => void;
	isLoading: boolean;
}

export const emptyUserContext: IUserProvider = {
	data: emptyUser,
	fetch: () => null as unknown as void,
	isLoading: true,
};

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
	const { data, isLoading, fetch } = useUser();

	return (
		<UserContext.Provider
			value={{
				data,
				isLoading,
				fetch,
			}}
		>
			{children}
		</UserContext.Provider>
	);
};

const UserContext = React.createContext(emptyUserContext);

export const useUserProvider = () => {
	return React.useContext(UserContext);
};
